import React, { useState, useEffect } from "react";
import { Col, Form, Row, Typography, message } from "antd";
import { useFieldArray, useForm } from "react-hook-form";
import GeneratedDoc from "../../../molecules/GeneratedDoc";
import { PopupConfirm } from "../../../atoms/Popup";
import axios from "axios";
import { leaseService } from "../../../../configs/constants";
import { CommonCard } from "../components";
import { useDispatch } from "react-redux";
import { createBooking, getBookingDetail, setBookingForm, setFormState, updateBooking } from "../ducks/actions";
import { useSelector } from "react-redux";
import AddDocs from "./AddDocs";
import RequiredDocs from "./RequiredDocs";
import { useNavigate, useParams } from "react-router";

export default (props) => {
  const {
    LEASEID,
    leaseData,
    RejectDocument,
    ApproveDocument,
    resetField,
    // isAdd,
    disableClone,
    isRenewal,
    tenantAccepted,
    generatedDocs,
    onUpdate,
    sendForEsignature,
    contractSent,
    sendSignatureBtn,
  } = props;

  const {
    control,
    setValue,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();

  const {
    fields: requiredDocuments,
    append: append,
    remove: remove,
  } = useFieldArray({
    control,
    name: "requiredDocuments",
  });

  const isAdd = true;

  // redux states
  const { configData, bookingForm, bookingDetails } = useSelector((state: any) => state.newBooking);

  const navigate = useNavigate();
  const { leaseId = bookingDetails.leaseId } = useParams();
  const [mapedDocuments, setMapedDocuments] = useState([]);
  const isBooking = Object.keys(bookingDetails).length > 0;

  const dispatch: any = useDispatch();

  const onRemoveDocument = async (key) => {
    PopupConfirm({
      title: `Are you sure you want to remove`,
      okText: "Yes",
      onOk: async () => {
        const url = `${leaseService}/leasing/removeDocument/${LEASEID}/ADDITIONAL_DOCUMENT`;
        await axios
          .get(url, {})
          .then((response) => {
            message.success("Removed document");
            onUpdate();
          })
          .catch((error) => {
            message.error(error.response.data.error);
          });
      },
    });
  };

  useEffect(() => {
    setValue("requiredDocuments", []);
    if (bookingDetails && bookingDetails?.requiredDocuments?.length > 0) {
      const arr = [];
      let requiredDocumentsDetail = [...bookingDetails?.requiredDocuments];
      requiredDocumentsDetail.map((data) => {
        if (data?.documentLabel && data?.documentId && data?.isExpired) {
          arr.push({
            type: data?.type,
            documentLabel: data?.documentLabel,
            status: data?.status,
            documentId: data?.documentId,
            isExpired: data?.isExpired,
            checked: data?.checked,
            isExpiry: data?.isExpiry,
          });
        } else {
          arr.push({
            type: data?.type,
            status: data?.status,
            title: data.title,
            checked: data?.checked,
            isExpiry: data?.isExpiry,
          });
        }
      });

      append(arr);
      // setValue("requiredDocuments", arr);
      // setRequiredDocArray(arr);
    } else {
      configData?.configuredDocuments?.length > 0 && append(configData?.configuredDocuments);
      // setRequiredDocArray(arr);
    }
  }, [bookingDetails, mapedDocuments]);

  const documentHandler = (data) => {
    switch (data.action) {
      case "reject":
        RejectDocument(data);
        break;
      case "accept":
        ApproveDocument(data);
        break;
      default:
        break;
    }
  };

  const onSubmit = async (data: any, type) => {
    let dataCopy = { ...(data || getValues()) };
    const selectedDocs =
      dataCopy?.requiredDocuments?.length > 0 ? dataCopy?.requiredDocuments?.filter((d) => d?.checked === true) : [];
    const additionalDocs =
      dataCopy?.additionalDocs?.length > 0
        ? dataCopy?.additionalDocs?.map((i) => ({
            type: i?.type?.value,
            status: "pending",
            documentLabel: i?.documentLabel,
          }))
        : [];

    let body = {
      requiredDocuments: [...selectedDocs, ...additionalDocs],
    };

    let valid = true;

    if (valid) {
      setValue("requiredDocuments", []);
      body = { ...bookingForm, ...body };
      dispatch(setBookingForm(body));
      props.parentState({ load: true });

      try {
        //removed as per bug: 8167 ----> ADDED AGAIN TO REGAIN THE FLOW LOGIC
        if (type === "done") body["createBooking"] = "yes"; //moved this condition down to not store this in redux

        const response = await dispatch(
          !isBooking ? createBooking(body) : updateBooking({ leaseId, body }) //removed: onlyBooking: type != "done" as discussed with ajay/vish //ADDED To fix /details in endpoint for done case
        );

        !isBooking && (await dispatch(getBookingDetail(response.data?.result)));

        setValue("additionalDocs", []);
        props.parentState({ load: false });
        message.success(response.data.message);
        if (type === "done") navigate("/bookings", { state: { clear: true } });
      } catch (error) {
        props.parentState({ load: false });
        message.error(error.response?.data?.error || error.response?.data?.message);
      }
    }
  };

  useEffect(() => {
    if (bookingDetails?.requiredDocuments?.length > 0) {
      setMapedDocuments(bookingDetails.requiredDocuments);
    } else if (configData?.configuredDocuments?.length > 0) {
      setMapedDocuments(configData.configuredDocuments);
    }
  }, [configData?.configuredDocuments, bookingDetails?.requiredDocuments]);

  return (
    <Form layout="vertical" name="bookingform" scrollToFirstError className="bf-main" onFinish={handleSubmit(onSubmit)}>
      <CommonCard
        label="Documents"
        leftBtnLabel="Back"
        rightBtnLabel="Done"
        handleDone={onSubmit}
        handleBack={() => dispatch(setFormState("back"))}
        parentState={props.parentState}
      >
        <Col span={24}>
          <Typography.Paragraph className="m-10 smallFont13 fp-para-line">
            Select documents required by the tenant during the booking process
          </Typography.Paragraph>
          <Row gutter={24}>
            {mapedDocuments && mapedDocuments?.length > 0 ? (
              mapedDocuments?.map((val, index) => {
                return (
                  <React.Fragment key={val?.title + index}>
                    <Col span={24}>
                      <RequiredDocs
                        setValue={setValue}
                        control={control}
                        index={index}
                        document={val}
                        isRenewal={isRenewal}
                        tenantAccepted={tenantAccepted}
                        documentHandler={documentHandler}
                        docLabel={["requiredBookingDocumentsList"]}
                      />
                    </Col>
                  </React.Fragment>
                );
              })
            ) : (
              <p>Loading...</p>
            )}
            {generatedDocs?.map((item, index) => {
              return (
                item?.addToLease === true &&
                item?.documentId && (
                  <React.Fragment key={index}>
                    <Col span={24}>
                      <GeneratedDoc
                        LEASEID={LEASEID}
                        title={item.label}
                        setValue={setValue}
                        onUpdate={onUpdate}
                        control={control}
                        sendForEsignature={sendForEsignature}
                        contractSent={contractSent}
                        sendSignatureBtn={sendSignatureBtn}
                        data={item}
                        documentId={item.documentId}
                        onRemoveDocument={() => onRemoveDocument(item?.documentName)}
                      />
                    </Col>
                  </React.Fragment>
                )
              );
            })}
            <Col span={24} className="other-docs">
              <>
                <AddDocs
                  setValue={setValue}
                  resetField={resetField}
                  errors={errors}
                  control={control}
                  isAdd={isAdd}
                  data={leaseData}
                  getValues={getValues}
                  requiredDocArray={requiredDocuments}
                  disableClone={disableClone}
                  requiredBookingDocumentsList={configData["requiredBookingDocumentsList"]}
                  page={"lease"}
                />
              </>
              {/* )} */}
            </Col>
          </Row>
        </Col>
      </CommonCard>
    </Form>
  );
};
